import React, { useEffect, useState } from "react";
import { Container, Row, Col, Button, Modal, Form } from "react-bootstrap";
import ProgramItem from "../ProgramItem/ProgramItem";
import { useHttpClient } from "../../hooks/http-hook";
import Notification from "../Notification/Notification";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../Context/AuthContext";


function AvailableProgram({ programs }) {
  const { sendRequest } = useHttpClient();
  const [showModal, setShowModal] = useState(false);
  const [courseCode, setCourseCode] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { authData } = useAuth();


  // Notification
  const [notificationParams, setNotificationParams] = useState({
    show: false,
    message: t("notification_default_message"),
    bg: "success",
  });

  const handleJoinCourse = async () => {
    setError("");

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/requests`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          credentials: "include",
          body: JSON.stringify({ programCode: courseCode }),
        }
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || t("error_occurred"));
      }

      if (response.status === 201) {
        setNotificationParams((prev) => ({
          show: true,
          message: data.message,
          bg: "success",
        }));
        setShowModal(false);
        setCourseCode("");
        setTimeout(() => {
          navigate(`/programs/${data.programId}`);
        }, 2000);
      } else if (response.status === 202) {
        setNotificationParams((prev) => ({
          show: true,
          message: t("access_request_sent"),
          bg: "success",
        }));
        setShowModal(false);
        setCourseCode("");
        setTimeout(() => {
          navigate("/myrequest");
        }, 2000);
      }
    } catch (err) {
      console.error(t("error_captured"), err);
      setError(err.message || t("error_occurred"));
    }
  };

  return (
    <Container className="my-5">
       {authData.isLoggedIn && (
      <div className="text-center mb-4">
        <Button variant="primary" onClick={() => setShowModal(true)}>
          {t("join_course_with_code")}
        </Button>
      </div>
      )}

      <Row xs={1} md={3} lg={4} className="g-4 justify-content-center">
        {programs.map((p, index) => (
          <Col key={index} className="d-flex justify-content-center">
            <ProgramItem
              id={p._id}
              title={p.title}
              description={p.description}
              level={p.level}
              categorie={p.categorie}
              duration={p.duration}
              imageUrl={p.imageUrl}
            />
          </Col>
        ))}
      </Row>

      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>{t("join_course")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group>
            <Form.Label>{t("enter_course_code")}</Form.Label>
            <Form.Control
              type="text"
              value={courseCode}
              onChange={(e) => setCourseCode(e.target.value)}
              placeholder={t("example_course_code")}
            />
            {error && <div className="text-danger mt-2">{error}</div>}
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              setShowModal(false);
              setError("");
            }}
          >
            {t("cancel")}
          </Button>
          <Button
            variant="primary"
            onClick={handleJoinCourse}
            disabled={courseCode.length !== 6}
          >
            {t("send_access_request")}
          </Button>
        </Modal.Footer>
      </Modal>
      <Notification
        notificationParams={notificationParams}
        setNotificationParams={setNotificationParams}
      />
    </Container>
  );
}

export default AvailableProgram;
